import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-consulta-localizacao',
  templateUrl: './consulta-localizacao.component.html',
  styleUrls: ['./consulta-localizacao.component.scss']
})
export class ConsultaLocalizacaoComponent implements OnInit {
  title = "LOCALIZAÇÃO";

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
  }

}
